import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import useEscape from "../../../hooks/useEscape";
import useKeyDown from "../../../hooks/useKeyDown";
import {
	navigateToCreateCandidate,
	navigateToCreateConsultant,
	navigateToCreateCustomer,
	navigateToCreateJob,
} from "../../../utils/route.utils";
import AppText from "../../Core/AppText/AppText";
import { CreateButton } from "../../Core/Button/Button";
import Flex from "../../Layout/Flex";
import Divider from "../Divider/Divider";

const CreateNewShortcut: React.FC = () => {
	const navigate = useNavigate();
	const [show, setShow] = useState(false);

	useKeyDown({
		onKeyDown: (e) => {
			if (e.shiftKey && (e.key === "N" || e.key === "n")) {
				setShow(true);
			}

			if (show && e.key === "Enter") {
				e.stopPropagation();
				e.preventDefault();
				navigateToCreateJob(navigate);
				setShow(false);
			}
		},
		disableIfAnyInputHasFocus: true,
	});

	useEscape({ onEscape: () => setShow(false), enabled: show });

	if (!show) {
		return null;
	}

	return (
		<Styles onClick={() => setShow(false)}>
			<div className="create-new-shortcut" onClick={(e) => e.stopPropagation()}>
				<Flex gap="1rem" direction="column">
					<AppText color="grayTextLight" size="s">
						Tryck "Esc" för att stänga fönstret
					</AppText>
					<Flex gap="0.5rem" direction="column">
						<CreateButton
							onClick={() => {
								navigateToCreateJob(navigate);
								setShow(false);
							}}
						>
							Skapa uppdrag (Enter)
						</CreateButton>
						<Divider />
						<CreateButton
							backgroundColor="secondary"
							onClick={() => {
								navigateToCreateCustomer(navigate);
								setShow(false);
							}}
						>
							Ny kund
						</CreateButton>
						<CreateButton
							backgroundColor="secondary"
							onClick={() => {
								navigateToCreateConsultant(navigate);
								setShow(false);
							}}
						>
							Ny konsult
						</CreateButton>
						<CreateButton
							backgroundColor="secondary"
							onClick={() => {
								navigateToCreateCandidate(navigate);
								setShow(false);
							}}
						>
							Ny kandidat
						</CreateButton>
					</Flex>
				</Flex>
			</div>
		</Styles>
	);
};

export default CreateNewShortcut;

const Styles = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-color: rgb(0, 0, 0, 0.15);
	z-index: 100;

	.create-new-shortcut {
		position: absolute;
		padding: 1rem;
		left: calc(50vw - 250px + 50px);
		top: 100px;
		width: 500px;
		min-height: 100px;
		background: white;
		border: 1px solid ${(props) => props.theme.colors.INPUT_BORDER_FOCUSED};
		border-radius: 15px;
		box-shadow: 0px 3px 30px rgba(0, 0, 0, 0.3);
	}
`;
